// bitkey は認証コード確認（本登録）の時点で 56 文字を超えるパスワードを拒否するため、入力時に弾く。OG の申込サイトと同じ定義
export const passwordRegexp = /^[a-zA-Z\d!"#$%&'()*+\-.,\/:;<=>?@\[\\\]^_`{|}~]{8,56}$/;
